import React, { Component } from 'react';
import BackupsTable from "../backups-table/backups-table";
import Docs from "../docs/docs";
import Settings from '../settings/settings';
import { Flex, Menu, MenuItem } from "monday-ui-react-core";
import { Versioning, Education, Settings as Sett, LearnMore} from "monday-ui-react-core/icons";
import { validateToken } from '../../services/backend-service';
import mondaySdk from "monday-sdk-js";
import classes from "./main-grid.module.scss";
import { isDocs, getSessionToken, getClientID, isSettings } from '../../services/backend-service';
import BoardViewBackupEditor from '../board-view-backup-editor/board-view-backup-editor';
import Help from '../help/help';

const FEATURE_WORKSPACE_VIEW = "AppFeatureWorkspaceView";

class MainGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      context: props.context || {},
      selectedMenuIndex: props.selectedMenuIndex || 0,
      isAdmin: false,
      isGuest: true,
      isViewOnly: true,
      userId: -1,
      workspaceId: -2,
      validToken: true,
      timeZoneOffset: 0,
      appFeature: FEATURE_WORKSPACE_VIEW
    };
  }

  componentDidMount() {
    const monday = mondaySdk();

    if(!isDocs()) {
      const validateOAuth = async () => {
        let validToken = false;
        try {
          await validateToken();
          validToken = true;
        } catch (err) {
          // Invalid token - do nothing
        }

        this.setState({
          validToken: validToken
        });
      }

      validateOAuth();
    }

    monday.listen("context", (res) => {
      this.setState({
        isAdmin: res.data.user.isAdmin,
        isGuest: res.data.user.isGuest,
        isViewOnly: res.data.user.isViewOnly,
        userId: res.data.user.id,
        workspaceId: res.data.workspaceId,
        timeZoneOffset: res.data.user.timeZoneOffset,
        appFeature: res.data.appFeature.type
      });
    });
  }

  clickMenu(index) {
    this.setState({
      context: this.state.context,
      selectedMenuIndex: index
    });
  }

  renderContent() {
    if(this.state.selectedMenuIndex === 0) {
      return <BackupsTable />;
    } else if(this.state.selectedMenuIndex === 1) {
      return <Help />;
    } else if(this.state.selectedMenuIndex === 2) {
      return <Docs />;
    } else if(this.state.selectedMenuIndex === 3) {
      return <Settings />;
    }
  }

  render() {
    if(isDocs() || !getSessionToken()) {
      return <Docs />;
    } else if(isSettings()) {
      return <Settings/>;
    } else {
      if(this.state.isViewOnly || this.state.isGuest) {
        return(
          <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
            <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} className={classes.emptyStateFlex}>
              <div className={classes.emptyStateComponent}>
                <div className={classes.emptyStateContainer}>
                  <img className={classes.permissionsImg} alt="Grand permissions" src="/monday/bb/v1/config/images/empty-set.png" />
                </div>
                <div className={classes.ctaContainer}>
                  <div className={classes.ctaContainerTitle}>Something's Missing</div>
                  <div className={classes.ctaContainerSubtitle}>Your current role doesn't allow access here. Please reach out if you think this is a mistake.</div>
                </div>
              </div>
            </Flex>
          </Flex>
        );
      }
      
      if(this.state.workspaceId === -1 || this.state.workspaceId === "-1" || this.state.workspaceId === null) {
        return(
          <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
            <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} className={classes.emptyStateFlex}>
              <div className={classes.emptyStateComponent}>
                <div className={classes.emptyStateContainer}>
                  <img className={classes.permissionsImg} alt="Workspace restriction" src="/monday/bb/v1/config/images/empty-set.png" />
                </div>
                <div className={classes.ctaContainer}>
                  <div className={classes.ctaContainerTitle}>Oops, not available here</div>
                  <div className={classes.ctaContainerSubtitle}>This functionality isn't available in the current workspace. Please switch to a different workspace.</div>
                </div>
              </div>
            </Flex>
          </Flex>
        );
      }

      return (
        <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
          { (!this.state.validToken) // OAuth token not yet generated - present authorization prompt
          ? <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW} className={classes.emptyStateFlex}>
            {/* {(this.state.isAdmin)
            ? <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} className={classes.emptyStateFlex}> */}
              <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} className={classes.emptyStateFlex}>
                <div className={classes.emptyStateComponent}>
                  <div className={classes.emptyStateContainer}>
                    <img className={classes.emptySetImg} alt="Grand permissions" src="/monday/bb/v1/config/images/permission-grant.png" />
                  </div>
                  <div className={classes.ctaContainer}>
                    <div className={classes.ctaContainerTitle}>Access authorization</div>
                    <div className={classes.ctaContainerSubtitle}>Board & Doc Backups needs to access your monday.com data to operate properly</div>
                  </div>
                  <a className={classes.authorizeLink} href={"https://auth.monday.com/oauth2/authorize?client_id=" + getClientID() + "&state=" + getSessionToken()}>Authorize</a>
                </div>
              </Flex>
            {/* : <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} className={classes.emptyStateFlex}>
              <div className={classes.emptyStateComponent}>
                <div className={classes.emptyStateContainer}>
                  <img className={classes.emptySetImg} alt="Grand permissions" src="/monday/bb/v1/config/images/permission-grant.png" />
                </div>
                <div className={classes.ctaContainer}>
                  <div className={classes.ctaContainerTitle}>Access authorization</div>
                  <div className={classes.ctaContainerSubtitle}>Please contact your system administrator to authorize Board & Doc Backups to access your monday.com data</div>
                </div>
              </div>
            </Flex>
            } */}
            </Flex>
          : (this.state.appFeature === FEATURE_WORKSPACE_VIEW)
              ? <Flex align={Flex.align.START} gap={Flex.gaps.MEDIUM} direction={Flex.directions.ROW} className={classes.fullWidth}>
                  <Menu>
                    <MenuItem 
                      id="menu-snapshots" 
                      icon={Versioning} 
                      title="Snapshots"
                      selected={this.state.selectedMenuIndex === 0}
                      onClick={() => {
                        this.clickMenu(0);
                      }}
                    />
                    <MenuItem 
                      id="menu-help" 
                      icon={LearnMore} 
                      title="Help" 
                      selected={this.state.selectedMenuIndex === 1}
                      onClick={() => {
                        this.clickMenu(1);
                      }}
                    />
                    {(this.state.isAdmin)
                    ? <MenuItem 
                        id="menu-docs" 
                        icon={Education} 
                        title="Admin Guide" 
                        selected={this.state.selectedMenuIndex === 2}
                        onClick={() => {
                          this.clickMenu(2);
                        }}
                      />
                    : <div></div>}
                    {(this.state.isAdmin)
                    ? <MenuItem 
                        id="menu-settings" 
                        icon={Sett} 
                        title="Settings" 
                        selected={this.state.selectedMenuIndex === 3}
                        onClick={() => {
                          this.clickMenu(3);
                        }}
                      />
                    : <div></div>}
                  </Menu>
                  {this.renderContent()}
                </Flex>
              : <BoardViewBackupEditor/>
          }
        </Flex>
      );
    }
  }
}

export default MainGrid;
